import { render, staticRenderFns } from "./waitdo.vue?vue&type=template&id=56bcc641&scoped=true"
import script from "./waitdo.vue?vue&type=script&lang=js"
export * from "./waitdo.vue?vue&type=script&lang=js"
import style0 from "./waitdo.vue?vue&type=style&index=0&id=56bcc641&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bcc641",
  null
  
)

export default component.exports